export default __webpack_public_path__ + "static/media/iconMinusWhite.8cc08ad9.svg";